module.exports = __webpack_public_path__ + "img/console-1.eaa7ff3f.png";